export default __webpack_public_path__ + "static/media/Brow_7_C4.b7b5dc1f.svg";